/**
 * Added effects of the attacks in Pokémon Champions, by move id. Generated by scripts/fetch-move-effects.mjs from
 * Pokémon Showdown's move data: do not edit by hand (run `npm run move-effects`).
 * - `chance` / `always`: effects on the target that may happen / always happen (a condition, flinch, confusion,
 *   or stat changes like "spd-1"; several stats changing together are comma-joined).
 * - `selfChance` / `selfAlways`: the same for the user (Meteor Mash's chance of +1 Atk, Close Combat's drops).
 */
export interface MoveEffects { chance?: string[]; always?: string[]; selfChance?: string[]; selfAlways?: string[] }

export const MOVE_EFFECTS: Readonly<Record<string, MoveEffects>> = {
  acidspray: {always:['spd-2']},
  airslash: {chance:['flinch']},
  ancientpower: {selfChance:['atk+1,def+1,spa+1,spd+1,spe+1']},
  appleacid: {always:['spd-1']},
  aquastep: {selfAlways:['spe+1']},
  armorcannon: {selfAlways:['def-1,spd-1']},
  aurawheel: {selfAlways:['spe+1']},
  axekick: {chance:['confusion']},
  barbbarrage: {chance:['psn']},
  bite: {chance:['flinch']},
  bittermalice: {always:['atk-1']},
  blazekick: {chance:['brn']},
  blizzard: {chance:['frz']},
  bodyslam: {chance:['par']},
  bounce: {chance:['par']},
  breakingswipe: {always:['atk-1']},
  bugbuzz: {chance:['spd-1']},
  bulldoze: {always:['spe-1']},
  chargebeam: {selfChance:['spa+1']},
  chillingwater: {always:['atk-1']},
  closecombat: {selfAlways:['def-1,spd-1']},
  crosspoison: {chance:['psn']},
  crunch: {chance:['def-1']},
  crushclaw: {chance:['def-1']},
  darkpulse: {chance:['flinch']},
  direclaw: {chance:['psn','par','slp']},
  discharge: {chance:['par']},
  dracometeor: {selfAlways:['spa-2']},
  dragonrush: {chance:['flinch']},
  drumbeating: {always:['spe-1']},
  dynamicpunch: {always:['confusion']},
  earthpower: {chance:['spd-1']},
  electroweb: {always:['spe-1']},
  energyball: {chance:['spd-1']},
  extrasensory: {chance:['flinch']},
  fakeout: {always:['flinch']},
  fierydance: {selfChance:['spa+1']},
  fireblast: {chance:['brn']},
  firefang: {chance:['brn','flinch']},
  firelash: {always:['def-1']},
  firepunch: {chance:['brn']},
  flamecharge: {selfAlways:['spe+1']},
  flamethrower: {chance:['brn']},
  flareblitz: {chance:['brn']},
  flashcannon: {chance:['spd-1']},
  focusblast: {chance:['spd-1']},
  freezedry: {chance:['frz']},
  gravapple: {always:['def-1']},
  gunkshot: {chance:['psn']},
  hammerarm: {selfAlways:['spe-1']},
  headlongrush: {selfAlways:['def-1,spd-1']},
  heatwave: {chance:['brn']},
  hurricane: {chance:['confusion']},
  icebeam: {chance:['frz']},
  icefang: {chance:['frz','flinch']},
  icehammer: {selfAlways:['spe-1']},
  icepunch: {chance:['frz']},
  iciclecrash: {chance:['flinch']},
  icywind: {always:['spe-1']},
  infernalparade: {chance:['brn']},
  inferno: {always:['brn']},
  ironhead: {chance:['flinch']},
  irontail: {chance:['def-1']},
  lavaplume: {chance:['brn']},
  leafstorm: {selfAlways:['spa-2']},
  liquidation: {chance:['def-1']},
  lowsweep: {always:['spe-1']},
  luminacrash: {always:['spd-2']},
  lunge: {always:['atk-1']},
  makeitrain: {selfAlways:['spa-1']},
  matchagotcha: {chance:['brn']},
  metalclaw: {selfChance:['atk+1']},
  meteormash: {selfChance:['atk+1']},
  moonblast: {chance:['spa-1']},
  mortalspin: {always:['psn']},
  mountaingale: {chance:['flinch']},
  mudshot: {always:['spe-1']},
  mysticalfire: {always:['spa-1']},
  nuzzle: {always:['par']},
  overheat: {selfAlways:['spa-2']},
  playrough: {chance:['atk-1']},
  poisonfang: {chance:['tox']},
  poisonjab: {chance:['psn']},
  pounce: {always:['spe-1']},
  psychic: {chance:['spd-1']},
  psyshieldbash: {selfAlways:['def+1']},
  pyroball: {chance:['brn']},
  rapidspin: {selfAlways:['spe+1']},
  razorshell: {chance:['def-1']},
  rockslide: {chance:['flinch']},
  rocktomb: {always:['spe-1']},
  scald: {chance:['brn']},
  scorchingsands: {chance:['brn']},
  shadowball: {chance:['spd-1']},
  shellsidearm: {chance:['psn']},
  skittersmack: {always:['spa-1']},
  skyattack: {chance:['flinch']},
  sludgebomb: {chance:['psn']},
  sludgewave: {chance:['psn']},
  snarl: {always:['spa-1']},
  snore: {chance:['flinch']},
  spiritbreak: {always:['spa-1']},
  steelwing: {selfChance:['def+1']},
  strugglebug: {always:['spa-1']},
  superpower: {selfAlways:['atk-1,def-1']},
  thunder: {chance:['par']},
  thunderbolt: {chance:['par']},
  thunderfang: {chance:['par','flinch']},
  thunderpunch: {chance:['par']},
  torchsong: {selfAlways:['spa+1']},
  trailblaze: {selfAlways:['spe+1']},
  triattack: {chance:['brn','par','frz']},
  triplearrows: {chance:['def-1','flinch']},
  tropkick: {always:['atk-1']},
  upperhand: {always:['flinch']},
  volttackle: {chance:['par']},
  waterfall: {chance:['flinch']},
  waterpulse: {chance:['confusion']},
  zapcannon: {always:['par']},
  zenheadbutt: {chance:['flinch']},
  zingzap: {chance:['flinch']},
};

/** Priority of every Champions move whose priority isn't 0, by move id (moves not listed have 0). */
export const MOVE_PRIORITY: Readonly<Record<string, number>> = {
  accelerock: 1,
  allyswitch: 2,
  aquajet: 1,
  avalanche: -4,
  babydolleyes: 1,
  banefulbunker: 4,
  beakblast: -3,
  bulletpunch: 1,
  circlethrow: -6,
  counter: -5,
  detect: 4,
  dragontail: -6,
  endure: 4,
  extremespeed: 2,
  fakeout: 3,
  feint: 2,
  firstimpression: 2,
  focuspunch: -3,
  followme: 2,
  helpinghand: 5,
  iceshard: 1,
  jetpunch: 1,
  kingsshield: 4,
  machpunch: 1,
  mirrorcoat: -5,
  protect: 4,
  quickattack: 1,
  quickguard: 3,
  ragepowder: 2,
  roar: -6,
  shadowsneak: 1,
  spikyshield: 4,
  suckerpunch: 1,
  trickroom: -7,
  upperhand: 3,
  vacuumwave: 1,
  watershuriken: 1,
  whirlwind: -6,
  wideguard: 3,
};
